// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"315995d6","231":"79d7496c","245":"66d58575","372":"cc5242a4","417":"79d7496c","705":"e007c0af","768":"1a52f16b","821":"4e49a367"}[chunkId] + ".chunk.css";
};